import React from "react";
import { useTranslation } from "react-i18next";
import Loading from "./Loading";

interface LoadingFallbackProps {
  message?: string;
  className?: string;
}

export const LoadingFallback: React.FC<LoadingFallbackProps> = ({
  message = "Loading...",
  className = "",
}) => {
  return (
    <div
      className={`flex flex-col items-center justify-center min-h-[200px] ${className}`}
    >
      <Loading />
      <div className="text-gray-600 text-sm">{message}</div>
    </div>
  );
};

export const PageLoadingFallback: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="w-full h-screen flex flex-col items-center justify-center bg-[#141517]">
      <Loading />
      <div className="text-white text-lg">{t("common.loading")}</div>
    </div>
  );
};
